import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { api } from "../redux/api";
import { useEffect, useState } from "react";

const NewInboundTemplateOptions = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { account } = useSelector((state) => state.queryParams);
  const currentScreen = useSelector(state => state.treeData.currentScreen)
  const [EDIVersions, setEDIVersions] = useState([]);
  const [NCPDPVersions, setNCPDPVersions] = useState([]);
  const [HL7Versions, setHL7Versions] = useState([]);
  const [FHIRVersions, setFHIRVersions] = useState([]);
  const [xmlVersions,setXMLVersions]= useState([]);
  
  useEffect(() => {
    const fetchPath = async () => {
      try {
        const response = await dispatch(
          api.endpoints.getRepositoryTemplates.initiate({
            account: account,
            template_type: currentScreen === "inbound" ? "INBOUND" : "OUTBOUND",
          },{forceRefetch:true})
        );
        if (!response || !response.data || !response.data.data) {
          throw new Error("Unable to load repository templates");
        }
        const extractPaths = (type) => {
          const data = response?.data?.data;
          const paths = data.filter((item) => {
            return type === item.path;
          });
          return paths;
        };
        const XMLPath = extractPaths('XML');
        const EDIpath = extractPaths('EDI');
        const HL7Path = extractPaths('HL7');
        const NCPDPPath = extractPaths('NCPDP');
        
        HL7Path[0].children.forEach(child =>{
          const p =[];
          const q=[]
          if(child.path === 'HL7'){
             child.children.forEach((subChild)=>{
                subChild.children.forEach(innerChild => {
                 p.push(innerChild.path)
                })
              
             })
             setHL7Versions(p.flat())

          }
          else {
            child.children.forEach((subChild)=>{
                subChild.children.forEach(innerChild => {
                 q.push(innerChild.path)
                })
              
             })
             setFHIRVersions(q.flat())

          }

        })
        const flattenPaths = (node) => {
          const paths = [];
          
          if (node.path) {
            paths.push(node.path);
          }
        
          if (Array.isArray(node.children)) {
            node.children.forEach((child) => {
              paths.push(...flattenPaths(child));
            });
          }
        
          return paths;
        };
        setNCPDPVersions(flattenPaths(NCPDPPath[0]))
        setEDIVersions(flattenPaths(EDIpath[0]))
        setXMLVersions(flattenPaths(XMLPath[0]));
      } catch (error) {
        console.log(error);
      }
    };
    fetchPath();
  }, [dispatch, account]); //eslint-disable-line react-hooks/exhaustive-deps
 

  const ntwOptions = {
    NTW_BASIC_EMPTY: t("BTN_CREATE_EMPTY_TEMPLATE"),
    NTW_COPY_SELECTED_TEMPLATE: t("BTN_CREATE_COPY_TEMPLATE"),
    NTW_DTD_TEMPLATE: t("BTN_CREATE_DTD_TEMPLATE"),
    NTW_SQL_TEMPLATE:t('BTN_CREATE_SQL_TEMPLATE'),
    NTW_REP_EDI_TEMPLATES: EDIVersions,
    NTW_REP_NCPDP_TEMPLATES: NCPDPVersions,
    NTW_REP_HL7_TEMPLATES: HL7Versions,
    NTW_REP_FHIR_TEMPLATES: FHIRVersions,
    NTW_REP_XML_TEMPLATES: xmlVersions,
    NTW_JSON_EMPTY:"Create an Empty JSON Template",
    NTW_JSON_DATA : t('BTN_CREATE_FROM_DATA'),
    NTW_JSON_SCHEMA : t('BTN_CREATE_FROM_SCHEMA'),
    NTW_EDI_SEF: t('BTN_CREATE_SEF_TEMPLATE'),
    NTW_DELIMITED_HEADER: t('BTN_CREATE_CSV_TEMPLATE'),
    NTW_XSD:t('BTN_CREATE_XSD_TEMPLATE'),
    NTW_XML_DATA:t('BTN_CREATE_XMLDATA_TEMPLATE')
  };

  return ntwOptions;
};

export default NewInboundTemplateOptions;
